import { locale as ENGLISH_TRANSLATIONS } from '../en';
import { locale as SPANISH_TRANSLATIONS } from '../es';

export const TRANSLATIONS: any = {
  en: ENGLISH_TRANSLATIONS,
  es: SPANISH_TRANSLATIONS,
};
